/**
 * MainLayout - Layout principal de la aplicación
 */

import type { ReactNode } from 'react';
import { Header } from './Header';

interface MainLayoutProps {
  children: ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 exo-container py-6">{children}</main>
      <footer className="py-4 text-center">
        <p className="text-xs text-slate-600">
          No necesitas motivación, necesitas un sistema fiable.
        </p>
        <p className="text-2xs text-slate-700 mt-1">Exocortex v2.0</p>
      </footer>
    </div>
  );
}
